import React, { useEffect, useState, useRef } from "react";
import "./replyQuery.css";
import Reply from "./Reply";
import axios from "../../../axios";
import NestedInput from "./NestedInput";
import { useSelector } from "react-redux";
import CrossQueryAttachment from "../Create Query/CrossQueryAttachment";
import ClipLoader from "react-spinners/ClipLoader";
import { debounce } from "@mui/material";
import assets from "../../../assets/assets";
import { iconData } from "../../../iconData";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import { IP } from "../../../internalServer";


const ReplyQuery = ({
  queryStatus,
  queryId,
  filter,
  setFilter,
  reply,
  setReply,
  date1,
  replyfetch,
  isGettingReply,
  setReplyFetch,
  isClearingSearch,
  isPreventApiCall,
  queries
}) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [nestedInput, setNestedInput] = useState(false);
  const [singleQuery, setSingleQuery] = useState({});
  const [replying, setReplying] = useState("");
  const [parentReply, setParentReply] = useState("");
  const [replyAttach, setReplyAttach] = useState([]);
  const [deleted, setDeleted] = useState(false);
  const [edited, setEdited] = useState(false);
  const [created, setCreated] = useState(true);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const { date, replyText, page, limit, searchClick } = filter;
  const [attachments, setAttachments] = useState([]);
  const [isReplySending, setIsReplySending] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  let [color, setColor] = useState("#FF9100");
  const [isLastPage, setIsLastPage] = useState(false);
  let [loading, setLoading] = useState(false);

  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  console.log(attachments);
  const getReplyReload = async () => {
    try {
      setIsGettingData(true)
      const response = await axios.get(`/query/reply/get/${queryId}?sortBy=-1`)
      response.data.data.length > 0 && setReply(response.data.data);

    } catch (error) {
      console.log(error)
    }
    setIsGettingData(false)
  }
  console.log("searchClick", searchClick)
  useEffect(() => {
    try {
      setLoading(true)
      const getSingleQuery = async () => {
        const response = await axios.get(`/query/get/${queryId}`)
        setSingleQuery(response.data.data);
        setLoading(false)
      };
      getSingleQuery();
    } catch (error) {
      console.log(error)
    }
  }, [reply, queryId]);

  const replyInputRef = useRef(null);
  useEffect(() => {
    if (parentReply && replyInputRef.current !== null) {
      replyInputRef.current.focus();
    }
  }, [parentReply]);

  console.log("replyText", replyText);

  const getReply = async () => {
    // if (isClearingSearch || isPreventApiCall) return;
    try {
      const formattedDate = date ? `&date=${encodeURIComponent(date1)}` : "";
      setIsGettingData(true);
      const formattedReplyText = replyText
        ? `&reply=${encodeURIComponent(replyText)}`
        : "";
      const response = await axios.get(
        `/query/reply/get/${queryId}?sortBy=-1${formattedDate}${formattedReplyText}`
      );
      console.log("search reply", response);

      if (response.data.data.length > 0) {
        setReply((prev) => [...response.data.data, ...prev]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingData(false);
    }
  };
  useEffect(() => {
    getReply();
  }, [deleted, edited, queryId, searchClick, replyfetch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newReply = {
      user_id: currentUser?.id,
      reply: replying,
      attachments: attachments
    };


    try {
      let res;
      setIsReplySending(true)
      if (parentReply) {
        res = await axios.post(
          `/query/${queryId}/${parentReply.id}/reply/create`,
          newReply
        );
      } else {
        if (newReply.reply !== "") {
          res = await axios.post(`/query/${queryId}/reply/create`, newReply);
        }
      }
      if (res) {
        // Reset input fields and state
        setReplying("");
        setParentReply(null);
        setReplyAttach([]);
        setAttachments([]);
        setNestedInput(false);
        setReply((prev) => [res.data.data, ...prev]);
        // Update the reply list immediately
        await getReplyReload(); // Refresh the replies list from the server
      }
      setIsReplySending(false)
    } catch (error) { }
  };

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("inner-scrollable-reply").clientHeight +
        document.getElementById("inner-scrollable-reply").scrollTop +
        1 >=
        document.getElementById("inner-scrollable-reply").scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.pptx|\.ppt|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleSetReplyAttach = (e) => {
    const file = e.target.files[0];

    if (file.size <= 10 * 1024 * 1024 && validateFileType(file)) {
      setReplyAttach(file);
      setIsValidFileType(true);
    } else {
      setIsValidFileType(false);
    }
  };
  const handleAttachment = async (files) => {
    let attachments1 = []; // Use a copy of the original attachments
    let totalSize = replyAttach.reduce((acc, file) => acc + file.size, 0);
    if (files) {
      if (replyAttach.length + files.length > 5) {
        window.alert("You can upload a maximum of 5 files.");
        return;
      } else {
        for (const file of files) {
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "audio/mpeg",
            "video/mp4",
          ];
          const maxSizeInMB = file.type.startsWith("image")
            ? 5
            : file.type === "audio/mpeg"
              ? 50
              : 250;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

          if (!allowedTypes.includes(file.type)) {
            window.alert(
              `Only PDF, JPEG, PNG, MP3, and MP4 files are allowed.`
            );
            continue;
          }

          if (file.size > maxSizeInBytes) {
            window.alert(
              `File size exceeds ${maxSizeInMB} MB for ${file.name}.`
            );
            continue;
          }

          totalSize += file.size;

          if (totalSize > 10 * 1024 * 1024) {
            window.alert("Total attachment size should not exceed 10 MB.");
            return;
          }

          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadReplyAttachment", file);
          setReplyAttach((prev) => [...prev, file]);
          try {
            let res = await axios.post(
              `/reply/uploadAttachment/userId/${currentUser?.id}`,
              formData
            );
            res && attachments1.push(res.data.data);
            console.log(attachments1);
          } catch (error) {
            console.log(error);
          }
        }
      }
      if (attachments1.length > 0) {
        setAttachments((prev) => [...prev, ...attachments1]);
      }
      setReplyAttach([]);
    }
  };

  useEffect(() => {
    const element = document.getElementById("inner-scrollable-reply");

    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //add code for auto scroll reply
  const handleScroll = debounce(async (e) => {
    if (e.target.scrollTop === 0 && !isGettingData) {
      setIsGettingData(true);
      await setFilter((prevState) => ({
        ...prevState,
        page: prevState.page + 1,
      }));
      setIsGettingData(false);
    }
  }, 300);


  const scrollContainerRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      const addedHeight =
        scrollContainer.scrollHeight - scrollContainer.clientHeight;
      scrollContainer.scrollTop = addedHeight;
    }
  }, [reply]);


  const handleRemoveAttachment = async (e, attachment, indexToRemove) => {
    e.stopPropagation()
    try {
      let res = await axios.delete(`/file/delete`, {
        data: { file_path: attachment },
      });

      if (attachments && attachments.length > 0) {
        const newArrayLimit = [...attachments];
        newArrayLimit.splice(indexToRemove, 1);
        setAttachments(newArrayLimit);
      }
      res &&
        setAttachments((prev) =>
          prev.filter((i) => {
            return i !== attachment;
          })
        );
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment)
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: true,
    });
  };

  const getAttachmentName = (attachment) => {
    let name = attachment.indexOf("_") > 0
      ? attachment.substring(attachment.indexOf("_") + 1)
      : attachment
    return name.length > 20 ? name.substring(0, 20) + "..." : name;
  }


  return (
    <>
      {queryStatus === "approved" && (
        <div className="mt-4 message_input_group">
          {nestedInput && (
            <NestedInput parentReply={parentReply} change={setNestedInput} />
          )}
          <form onSubmit={handleSubmit}
            className="border rounded p-3"
            style={{ backgroundColor: "#f9f9f9" }}
          >
            <div className="mb-5">
              <textarea
                id="reply"
                ref={replyInputRef}
                value={replying}
                onChange={(e) => setReplying(e.target.value)}
                className="form-control"
                placeholder="Post Your Answer ..."
                maxLength={250}
                rows={2}
                style={{
                  resize: "vertical",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "8px",
                  padding: "12px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                }}
              />
            </div>
            <div className="d-flex gap-4 message_input_icons mr-1">
              <div className="mb-2 d-flex flex-wrap gap-2">
                {attachments.map((attachment, index) => (
                  <div className="d-flex justify-content-end cursor-pointer">
                    <div
                      className="flex query_attach_box align-items-center"
                      onClick={(e) => {
                        e.stopPropagation()
                        const fileType = attachment.split(".").pop();
                        if (
                          fileType === "jpg" ||
                          fileType === "jpeg" ||
                          fileType === "png" ||
                          fileType === "mp4" ||
                          fileType === "JPG" ||
                          fileType === "JPEG" ||
                          fileType === "PNG" ||
                          fileType === "MP4"
                        ) {
                          handleClick(attachment);
                        } else if (
                          fileType === "pdf" ||
                          fileType === "PDF" ||
                          fileType === "ppt" ||
                          fileType === "PPT" ||
                          fileType === "PPTX" ||
                          fileType === "pptx"
                        ) {
                          handleClickforpdf(attachment);
                        }
                      }}
                    >
                      <>
                        {attachment.split(".").pop() === "jpg" ||
                          attachment.split(".").pop() === "jpeg" ||
                          attachment?.split(".").pop() === "JPEG" ||
                          attachment?.split(".").pop() === "JPG" ||
                          attachment?.split(".").pop() === "PNG" ||
                          attachment?.split(".").pop() === "mp4" ||
                          attachment?.split(".").pop() === "MP4" ||
                          attachment.split(".").pop() === "png" ? (
                          <div
                            // key={index}
                            onClick={() => {
                              if (!isError) {
                                handleClick(attachment);
                              }
                            }}
                            className="d-flex gap-2 p-1"
                          >
                            <div className="d-flex align-items-center">
                              <img
                                style={{ maxHeight: "19px" }}
                                src={`${iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment.substring(
                                      attachment.lastIndexOf(".") + 1
                                    )
                                )?.icon
                                  }`}
                                alt=""
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className="d-flex align-items-center pdf_logo"
                            onClick={() => handleClickforpdf(attachment)}
                          >
                            <img
                              className="attachLogoActivity w-4"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                        )}
                      </>
                      &nbsp;&nbsp;
                      {getAttachmentName(attachment)}
                      &nbsp;
                      <img
                        onClick={(e) => handleRemoveAttachment(e, attachment, index)}
                        src={assets.CrossIcon}
                        alt="icon"
                        className="m-2 w-4"
                      />
                      <span style={{ color: "#677489" }} className="">
                        {/* (45kb) */}
                      </span>
                    </div>
                    {/* <CrossQueryAttachment
                      key={index}
                      attachment={item}
                      indexToRemove={index}
                      setAttachment2={setAttachments}
                      attachMent2={attachments}
                      setAttach={setAttachments}
                    /> */}
                  </div>
                ))}
              </div>
              <input
                id="attachFile"
                accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleAttachment(e.target.files)}
              />
              <label
                className="postPublicBtn postAttachBtn"
                htmlFor="attachFile"
              >
                <img
                  src={assets.UploadIcon}
                  height="80%"
                  width="30px"
                  alt="Attach Icon"
                  style={{
                    objectFit: "contain",
                    maxHeight: "100%",
                  }}
                />
                {/* {replyAttach && " Attached"} */}
              </label>
              {isReplySending ? (
                <img
                  style={{ width: "32px", height: "32px" }}
                  src="/gif/Loader.gif"
                  alt=""
                />
              ) : (
                <>
                  <button
                    id="submitFile"
                    type="submit"
                    style={{ display: "none" }}
                    className="mr-4"
                  ></button>
                  <label
                    htmlFor="submitFile"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#8c4c24",
                      color: "white",
                      padding: "5px 14px",
                      borderRadius: "6px",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    Post
                  </label>
                </>
              )}
            </div>
          </form>
        </div>
      )}

      <span className="count_reply_header">{`${singleQuery?.reply_count ? singleQuery?.reply_count : 0
        } Replies`}</span>
      <div
        style={{ height: "40vh", overflowY: "scroll" }}
        onScroll={handleScroll}
        className="reply_box orange-scrollBar"
        ref={scrollContainerRef}
      >
        {
          (reply.length > 0) ? (
            <ul>
              {reply
                .slice(0)
                .reverse().map((data, index) => (
                  <Reply
                    key={`${data.id}_${index}_${reply.length}`}
                    queryStatus={queryStatus}
                    setReply={setReply}
                    setParentReply={setParentReply}
                    setNestedInput={setNestedInput}
                    setDeleted={setDeleted}
                    setEdited={setEdited}
                    reply={data}
                    queryId={queryId}
                    setFilter={setFilter}
                    getReplyReload={getReplyReload}
                  />
                ))}
            </ul>
          ) : isGettingData || isGettingReply ? (<img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" style={{ width: "100px", height: "110px", marginLeft: "610px" }} />) : <div>No Reply Found!</div>
        }
      </div>

      <>
        {!isValidFileType && (
          <p id="errorMsg">
            "Exceeded Limit !!
            Max 5 attachments and total of 10 MB size is allowed."
          </p>
        )}
      </>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
};

export default ReplyQuery;
